import './register_common_react';
import { reactOnCms } from 'common/js/react_on_cms';
import GridGallery from 'sealink/js/grid_gallery';
import { Card } from 'sealink/react-components/cards';
import CarouselGallery from 'sealink/react-components/carousel-gallery';
import CategoryCard from 'sealink/react-components/category-card';
import CategoryCardsCarousel from 'sealink/react-components/category-cards-carousel';
import EventFilter from 'sealink/react-components/event-filter';
import ExperienceFilter from 'sealink/react-components/experience-filter';
import GiftVouchers from 'sealink/react-components/gift-vouchers';
import NationalCardsFilter from 'sealink/react-components/national-cards-filter';
import NewsCardsCarousel from 'sealink/react-components/news-cards-carousel';
import RelatedEntriesCarousel from 'sealink/react-components/related-entries-carousel';
import Experience from 'components/experience';
import Video from 'components/video';
import FerryTimetable from 'tenants/sealink/ferry_timetable';
import TicketHistory from 'tenants/sealink/ticket_history';

reactOnCms.register({
  CarouselGallery,
  RelatedEntriesCarousel,
  GridGallery,
  Video,
  CategoryCard,
  EventFilter,
  ExperienceFilter,
  GiftVouchers,
  NewsCardsCarousel,
  CategoryCardsCarousel,
  NationalCardsFilter,
  FerryTimetable,
  Card,
  Experience,
  TicketHistory,
});
